const AppConfig = {
  // মূল Flask API সার্ভার
  API_BASE_URL: 'https://all-star-gadget-server.sparkx-ai.shop/',
  CompanyName: 'All Star Gadget',
  phoneNumber: '01987757794',
  contactEmail: 'allstargadget19@gmail.com',
  // WhatsApp লিঙ্ক
  WhatsAppLink: 'https://wa.me/01987757794',
  WhatsAppNumber: '+8801987757794',
  // Facebook Messenger লিঙ্ক
  MessengerLink: 'https://m.me/allstargadget',
  // WhatsApp ডিফল্ট মেসেজ
  WhatsAppDefaultMessage: 'Hello! I visited your website and would like some information.',
  DeliveryManURL: 'https://all-star-gadget-server.sparkx-ai.shop/delivery-man',
  WELCOME_COUPON_CODE: 'WELCOME10', // নতুন ব্যবহারকারীদের জন্য
};

export default AppConfig;